import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	ViewEncapsulation,
	ChangeDetectorRef,
	OnChanges,
	ChangeDetectionStrategy,
} from '@angular/core';
import { TopSearchesService } from '@domain/services/top-searches.service';
import { CapacitySearch } from '@domain/interface/capacity-search';
import { UtilService } from '@service/util/util.service';
import { SharedService } from '@service/shared/shared.service';
import { IS_NOT_EMPTY } from 'cargo-chief-commons';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { finalize } from 'rxjs/operators';

@Component({
	selector: 'app-search-horizontal-list',
	templateUrl: './search-horizontal-list.component.html',
	styleUrls: ['./search-horizontal-list.component.scss'],
	encapsulation: ViewEncapsulation.None,
	// changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchHorizontalListComponent implements OnInit, OnDestroy {
	@Input() showChipsVertically: boolean = false;
	@Input() isLoadingSearchResults: boolean = true;
	@Input() routeSearchPath: string = 'capacity';
	@Input() setHorizontalScroll: boolean = false;
	@Input() layoutAlign: string = 'center center';

	topSearches: CapacitySearch[] = [];
	TOP_SEARCHES_SIZE: number = 5;
	private topSearchesSubscription;

	constructor(
		private topSearchesService: TopSearchesService,
		private utilService: UtilService,
		private sharedService: SharedService,
		public cargochief: Cargochief,
		private cdRef: ChangeDetectorRef
	) {}

	ngOnInit() {
		if (this.isRouteSearchTrucks()) {
			this.getTopSearches();
		}

		this.topSearchesSubscription = this.sharedService
			.getSearchCompletedEvent()
			.subscribe((data: any) => {
				if (this.isRouteSearchTrucks() && !this.utilService.isNullOrUndefined(data)) {
					this.getTopSearches();
				}
			});
	}

	getTopSearches() {
		if (this.topSearches?.length == 0) {
			this.isLoadingSearchResults = true;
		}
		// this.topSearches = [];
		this.topSearchesService
			.fetch()
			.pipe(
				finalize(() => {
					this.isLoadingSearchResults = false;
				})
			)
			.subscribe(
				(result: any) => {
					if (!this.utilService.isNullOrUndefined(result)) {
						this.topSearches = [...result];
						this.topSearches.map((search: any) => {
							search.abbreviatedTrailerTypes = this.getAbbreviatedTrailerTypesString(
								search.trailerType
							);
						});
					}
				},
				(error) => {
					console.log('Unable to load top searches: ', error);
				}
			);
	}

	setQueryParams(search: CapacitySearch) {
		this.utilService.setCapacitySearchQueryParams(search, this.routeSearchPath);
	}

	isRouteSearchTrucks(): boolean {
		return (
			window.location.href.indexOf('capacity') > 0 || window.location.href.indexOf('dashboard') > 0
		);
	}

	getAbbreviatedTrailerTypesString(trailerTypesString: string) {
		if (!IS_NOT_EMPTY(trailerTypesString)) {
			return '';
		}
		return trailerTypesString
			.split(',')
			.reduce((abbreviatedTrailerTypesString: string, trailerType: string, index: number) => {
				return (
					abbreviatedTrailerTypesString +
					(index == 0 ? '' : ',') +
					this.utilService.getAbbreviatedTrailerTypes(trailerType)
				);
			}, '');
	}

	ngOnDestroy() {
		if (!this.utilService.isNullOrUndefined(this.topSearchesSubscription)) {
			this.topSearchesSubscription.unsubscribe();
		}
	}
}
